export default __webpack_public_path__ + "static/media/ornament_2.e6b70403.png";